import { pcBuildReq } from 'src/constants/quotation/pcBuild';
import { CategoriesEnum } from 'src/enums';
import { Quotation } from 'src/types';

export const isQuotationPCBuild = (quotationItemsArg?: Quotation[]) => {
  // Check if pcBuildReq is fulfilled
  const itemsThatPassedPCBuild = quotationItemsArg?.filter(
    (x) =>
      x?.product?.category_id &&
      pcBuildReq.includes(x?.product?.category_id) &&
      x?.product?.product_id
  );

  // meaning 3 items was fulfilled. 3 only because sometimes casing has built in PSU
  if (itemsThatPassedPCBuild && itemsThatPassedPCBuild?.length > 3) {
    const hasMobo = itemsThatPassedPCBuild?.find(
      (item) => item?.product?.category_id === CategoriesEnum.Motherboard
    );
    const hasCPU = itemsThatPassedPCBuild?.find(
      (item) => item?.product?.category_id === CategoriesEnum.CPU
    );
    const hasCasing = itemsThatPassedPCBuild?.find(
      (item) => item?.product?.category_id === CategoriesEnum.Casing
    );
    const hasRAM = itemsThatPassedPCBuild?.find(
      (item) => item?.product?.category_id === CategoriesEnum.RAM
    );

    const hasPSUInCateg = itemsThatPassedPCBuild?.find(
      (item) => item?.product?.category_id === CategoriesEnum.PSU
    );
    const hasPSUInCasing = hasCasing?.product?.product_name?.includes('PSU');

    if (
      hasMobo &&
      hasCPU &&
      hasCasing &&
      hasRAM &&
      (hasPSUInCateg || hasPSUInCasing)
    ) {
      return true;
    }
    return false;
  }
};
